const FilterableTabs = {
  init() {
    $('.js-tabs-filterable').each(
      (_, el) => this.setup( $(el) )
    );
  },
  setup($tab_group) {
    const $nav = $('<nav class="c-tabs__nav" />');
    const $select = $('<select class="c-tabs__select" />');

    $tab_group.find('.js-tabs-title').each( (i, el) => {
      const $title = $(el);
      const title_text = $title.text();
      let deep_link = '';
      let tab_active = '';

      // If there is a hash value assign the text value to deep_link without the '#'
      if (window.location.hash) {
        deep_link = window.location.hash.replace('#', '');
      }

      const $panel = this.getPanelForTitle($title);
      if ( $panel.length === 0 ) { return; }

      let panel_id = $panel.attr('id');
      if ( !panel_id ) {
        panel_id = title_text.replace(/\W+/g, '-');
        $panel.attr('id', panel_id);
      }
      // Activate the panel in URL hash value default to the first panel
      if (deep_link == $panel.attr('id') ) {
        $panel.addClass('is-active');
        tab_active = 'is-active';
        $('html, body').animate({
          scrollTop: $panel.offset().top - 200
        }, 2000);
      } else if ( i === 0 && deep_link === '') {
        $panel.addClass('is-active');
        tab_active = 'is-active';
      }

      $nav.append(`<a href="#${panel_id}" class="c-tabs__nav-link js-tab-nav-link ${tab_active}">${title_text}</a>`);
      $select.append(`<option value="${panel_id}">${title_text}</option>`);
    } );
    $tab_group.prepend($nav);
    $tab_group.prepend($select);

    // Nav link click - desktop
    $tab_group.on('click', '.js-tab-nav-link', event => this.navClick(event));
    $select.change( () => this.select( $select.val() ) );
  },
  select( panel_id ) {
    const $panel = this.getPanelForId(panel_id);
    if ( $panel.length === 0 ) { return; }

    $panel.addClass('is-active')
      .siblings().removeClass('is-active')
    ;
  },
  // On desktop
  navClick(event) {
    event.preventDefault();

    const $link = $(event.target);
    const $panel = this.getPanelForLink($link);
    if ( $panel.length === 0 ) { return; }

    // Change nav state
    $link.addClass('is-active')
      .siblings().removeClass('is-active')
    ;

    // Change panel state
    $panel.addClass('is-active')
      .siblings().removeClass('is-active')
    ;
  },
  getPanelForId(panel_id) {
    return $(`#${panel_id}`);
  },
  getPanelForLink($link) {
    let id = $link.attr('href');
    if ( id.substring(0, 1) === '#' ) {
      id = id.substring(1);
    }

    const $group = $link.closest('.js-tabs-filterable');
    return $group.find(`#${id}`);
  },
  getPanelForTitle($title) {
    // Try to look by helper class first
    let $panel = $title.closest('.js-tabs-panel');

    if ( $panel.length === 0 ) {
      // Fall back to markup structure
      $panel = $title.closest('div');
    }

    return $($panel);
  },
}

$(FilterableTabs.init.bind(FilterableTabs));
